import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';

export interface UmpireComponentQuotation
  extends UmpireComponent<UmpireComponentTypeEnum.QUOTATION> {
  content: string;
}
